<template>
  <div class="d-flex flex-column align-items-center">
    <div
      @click="$emit('click', product)"
      :class="`product ${selected ? 'active' : ''} ${
        !product.selectable ? 'notSelectable' : ''
      }`"
      :style="cssString"
    >
      <div class="title">
        {{ product.title }}
      </div>
      <div class="image-wrapper">
        <img :src="product.backgroundImage" class="product-image" />
      </div>
      <div
        v-if="product.selectable"
        class="d-flex align-items-center justify-content-between counter"
      >
        <template v-if="selected && product.id != 4">
          <button
            class="minus"
            @click.stop="$emit('decrease', product)"
          ></button>
          <text-input name="display" class="display" v-text="product.count" />
          <button
            class="plus"
            @click.stop="$emit('increase', product)"
          ></button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      product: {
        required: true,
        type: Object
      },
      selected: {
        required: true,
        type: Boolean
      },
      colorSchema: {
        required: true,
        type: String
      },
      cssString: String
    }
  }
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 16px;
}

.product {
  height: 290px;
  width: 279px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 20px;
  margin-top: 50px;
  position: relative;
  background-color: #FFFBD6;
  border: 1px solid var(--brand-color);
  border-radius: 20px;
  transition: all 0.3s;

  @media (max-width: 767px) {
    width: 290px;
  }

  &.active {
    background-color: var(--brand-color);
    .title {
      color: #fff;
    }
  }

  &:not(.notSelectable):hover {
    cursor: pointer;
  }

  .product-image {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .image-wrapper {
    width: 100%;
    height: 170px;
    margin-top: 20px;
    padding: 0 20px;
  }

  .counter {
    height: 20px;
    margin-top: 5px;

    .minus {
      background-image: url("../../../assets/icons/minus.svg");
      background-repeat: no-repeat;
      background-size: contain;
      width: 20px;
      height: 20px;
      border: 0;
      border-radius: 2px;
      margin-right: 20px;

      @media (max-width: 767px) {
        margin-right: 10px;
      }
    }

    .plus {
      background-image: url("../../../assets/icons/plus.svg");
      background-repeat: no-repeat;
      background-size: contain;
      width: 20px;
      height: 20px;
      border: 0;
      border-radius: 2px;
      margin-left: 20px;
    }

    .display {
      height: 23px;
      width: 40px;
      background-color: #fff;
      border-radius: 4px;
      padding-top: 10px;
    }
  }

  // &.notSelectable {
  //   opacity: 0.6;
  //   -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  //   filter: grayscale(100%);
  // }
}
</style>
